import { useContext } from "react";
import { useSelector } from "react-redux";
import { Tag } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  tags: Tag[];
  retrieveResourcesTags(
    request: Boundaries["retrieveResourcesTags"]["request"],
  ): void;
}

function useRetrieveResourcesTags(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveResourcesTagsRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveResourcesTagsRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveResourcesTagsRequestFailure,
    ),
    tags: useSelector(selector.getResourcesTags),
    retrieveResourcesTags: core.retrieveResourcesTags,
  };
}

export { useRetrieveResourcesTags };
